import { TrackedValue } from '../TrackedValue';

export enum PartnershipMode {
  LIVE = 'LIVE',
  TEST = 'TEST',
  OFF = 'OFF',
}

export enum PartnerName {
  REVLIFTER = 'RevLifter',
  TVSCIENTIFIC = 'TvScientific',
  UPSELLIT = 'UpSellit',
  ACCELERATE = 'Accelerate',
  INTENTLY = 'Intently',
  ROKT = 'Rokt',
}

export interface PartnershipV1 {
  name: PartnerName;
  key: string;
  mode: PartnershipMode;
}

export const isPartnershipV1 = (object: unknown): object is PartnershipV1 => {
  const partnership = object as PartnershipV1;
  return (
    !!partnership &&
    partnership.name !== undefined &&
    partnership.key !== undefined &&
    partnership.mode !== undefined
  );
};

export const isPartnershipArrayV1 = (
  object: unknown
): object is PartnershipV1[] => {
  if (!Array.isArray(object)) {
    return false;
  }

  return object.every((item) => isPartnershipV1(item));
};

export const isTrackedPartnershipV1 = (
  object: unknown
): object is TrackedValue<PartnershipV1> => {
  const partnership = object as TrackedValue<PartnershipV1>;
  return (
    !!partnership &&
    partnership.value.name !== undefined &&
    partnership.value.key !== undefined &&
    partnership.value.mode !== undefined
  );
};

export const isTrackedPartnershipArrayV1 = (
  object: unknown
): object is TrackedValue<PartnershipV1>[] => {
  if (!Array.isArray(object)) {
    return false;
  }

  return object.every((item) => isTrackedPartnershipV1(item));
};
